import {
  Button,
  Flex,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Td,
  Text,
  Tr,
  useDisclosure,
  useToast,
  Tooltip,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import client from "../../utils/client";
import { useState } from "react";

const ROLES = [
  { label: "Não-Maçom", value: process.env.REACT_APP_NOMASON },
  { label: "Maçom", value: process.env.REACT_APP_MASON },
  { label: "Notícias", value: process.env.REACT_APP_NEWS },
  { label: "Blog", value: process.env.REACT_APP_BLOG },
  { label: "Com. Cultural", value: process.env.REACT_APP_CULTURAL },
  { label: "Administrador", value: process.env.REACT_APP_ADMINISTRATOR },
];

const getRoleLabel = (typeValue) => {
  const found = ROLES.find((r) => r.value === typeValue);
  return found ? found.label : "Usuário";
};

const UserCard = ({ user, onRoleChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const region = process.env.REACT_APP_S3_REGION;

  const handleRoleChange = async (e) => {
    const newType = e.target.value;
    if (!newType || newType === user.type) return;
    setIsLoading(true);
    try {
      await client.post(`/users/promote/${user.userId}`, { type: newType });
      toast({
        title: `Permissão de ${user.name} atualizada para "${getRoleLabel(newType)}"`,
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      if (onRoleChange) onRoleChange(user.userId, newType);
    } catch {
      toast({ title: "Erro ao atualizar permissão", status: "error", duration: 4000, isClosable: true });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent borderRadius="1rem">
          <ModalHeader fontWeight={700} fontSize="1.1rem" borderBottom="1px solid" borderColor="gray.100" pb={3}>
            {user?.name}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={4}>
            <Flex flexDir="column" gap={2} fontSize="0.9rem">
              {[
                ["Perfil", getRoleLabel(user?.type)],
                ["Email", user?.email],
                ["Telefone", user?.phoneNumber],
                ["Oriente", `${user?.city} - ${user?.state}`],
                ["Endereço", user?.address],
                ["Trabalho", user?.job],
                ["CPF", user?.cpf],
                ["Aniversário", user?.bithdate],
                ["Maçom ativo", user?.isActiveMason === "true" ? "Ativo" : "Adormecido"],
                ["Loja", user?.lodge],
                ["Rito", String(user?.rite || "").toUpperCase()],
                ["Potência", user?.obedience],
                ["Grau Simbólico", user?.symbolicGrade === "1" ? "Aprendiz" : user?.symbolicGrade === "2" ? "Companheiro" : "Mestre"],
                ["CIM", user?.cim],
              ].map(([label, value]) => (
                <Flex key={label} gap={2}>
                  <Text fontWeight={700} minW="110px" color="gray.600" fontSize="0.82rem">{label}:</Text>
                  <Text color="gray.800">{value}</Text>
                </Flex>
              ))}
              <Flex justifyContent="center" mt={3}>
                <Image
                  src={`https://${bucket}.s3.${region}.amazonaws.com/user_images/${user?.photo}`}
                  borderRadius="50%"
                  w="120px"
                  h="120px"
                  objectFit="cover"
                  border="3px solid"
                  borderColor="green.200"
                />
              </Flex>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" variant="outline" size="sm" onClick={onClose}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Tr>
        <Td maxW="150px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" title={user?.name} fontSize="0.82rem">
          {user?.name}
        </Td>
        <Td maxW="180px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontSize="0.82rem">
          {user?.email}
        </Td>
        <Td fontSize="0.82rem" whiteSpace="nowrap">{user?.phoneNumber}</Td>
        <Td>
          <Select
            size="xs"
            value={user?.type || ""}
            onChange={handleRoleChange}
            isDisabled={isLoading}
            minW="130px"
            maxW="150px"
            borderRadius={6}
            bg="white"
            borderColor="gray.300"
            fontSize="0.78rem"
          >
            {ROLES.map((role) => (
              <option key={role.value} value={role.value}>
                {role.label}
              </option>
            ))}
          </Select>
        </Td>
        <Td>
          <Tooltip label="Detalhar usuário">
            <IconButton
              colorScheme="green"
              variant="ghost"
              aria-label="Detalhes"
              icon={<SearchIcon />}
              size="xs"
              onClick={onOpen}
            />
          </Tooltip>
        </Td>
      </Tr>
    </>
  );
};

export default UserCard;
